export default __webpack_public_path__ + "static/media/users.c5ff2ed8.svg";